import { render, staticRenderFns } from "./updateOrCreateProject.vue?vue&type=template&id=3deb1c14"
import script from "./updateOrCreateProject.vue?vue&type=script&lang=js"
export * from "./updateOrCreateProject.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports